export const typesMap = {
  IN_PROGRESS: 0, // – На проверке
  CALL: 0, // – На проверке
  RE_CALL: 0, // – Готова к вызову
  ACCEPTED: 1, // – Готова к заселению
  EXPLOITATION: 2, // - Передана в эксплуатацию
  NOT_ACCEPTED: 3, // – Не принята
  NOT_READY: 4, // Не готова к вызову
  NULL: 5, // – Готова к вызову
};
